import { render } from "./FilterTodos.vue?vue&type=template&id=5cca0e5c"
import script from "./FilterTodos.vue?vue&type=script&lang=js"
export * from "./FilterTodos.vue?vue&type=script&lang=js"

import "./FilterTodos.vue?vue&type=style&index=0&id=5cca0e5c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__